import { render, staticRenderFns } from "./IconElementVideo.vue?vue&type=template&id=a83158b6&"
import script from "./IconElementVideo.vue?vue&type=script&lang=js&"
export * from "./IconElementVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a83158b6')) {
      api.createRecord('a83158b6', component.options)
    } else {
      api.reload('a83158b6', component.options)
    }
    module.hot.accept("./IconElementVideo.vue?vue&type=template&id=a83158b6&", function () {
      api.rerender('a83158b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconElementVideo.vue"
export default component.exports